import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import HomeIcon from '@mui/icons-material/Home';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ChatIcon from '@mui/icons-material/Chat';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ApartmentIcon from '@mui/icons-material/Apartment';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import LogoutIcon from '@mui/icons-material/Logout';
import {

  Switch,
  Route,
  Link,

  useRouteMatch
} from "react-router-dom";
import AddAppartment from './AddAppartment/AddAppartment';
import MyBookings from './MyBookings/MyBookings';
import Reviews from './Reviews/Reviews';
import Pay from './Pay/Pay';
import Managebooking from './ManageBooking/Managebooking';
import ManageAppartments from './ManageAppartments/ManageAppartments';
import MakeAdmin from './MakeAdmin/MakeAdmin';
import useAuth from '../Hooks/useAuth';

const drawerWidth = 240;

function Dashboard(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const {user, admin, logOut} = useAuth();

  let { path, url } = useRouteMatch();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <Toolbar />
      
      <Divider />

   
    
      <List>
        
          <ListItem button>
            <ListItemIcon>
             <HomeIcon />
            </ListItemIcon>
            <Link to='/home' style={{ textDecoration: 'none', fontWeight: 'bold', color: '#184640' }}><ListItemText primary="Home"/></Link>
          </ListItem>
          <Divider/>
          <ListItem button>
            <ListItemIcon>
             <AssignmentIcon />
            </ListItemIcon>
            <Link to={`${url}/mybookings`} style={{ textDecoration: 'none', fontWeight: 'bold', color: '#184640' }}><ListItemText primary="My Bookings"/></Link>
          </ListItem>
          <ListItem button>
            <ListItemIcon>
             <ChatIcon />
            </ListItemIcon>
            <Link to={`${url}/addreview`} style={{ textDecoration: 'none', fontWeight: 'bold', color: '#184640' }}><ListItemText primary="Add Review"/></Link>
          </ListItem>
          <ListItem button>
            <ListItemIcon>
             <CreditCardIcon />
            </ListItemIcon>
            <Link to={`${url}/pay`} style={{ textDecoration: 'none', fontWeight: 'bold', color: '#184640' }}><ListItemText primary="Pay"/></Link>
          </ListItem>
          <Divider/>
         {
           !admin &&  <ListItem button>
            
           <ListItemIcon>
            <LogoutIcon />
           </ListItemIcon>
           <button onClick={logOut} className='custom-btn'>Logout</button>
         </ListItem>
         }
       
      </List>
      <Divider />
      <List>
        
          {
            admin && <List>
              <ListItem button>
            <ListItemIcon>
             <LibraryBooksIcon />
            </ListItemIcon>
            <Link to={`${url}/managebookings`} style={{ textDecoration: 'none', fontWeight: 'bold', color: '#184640' }}><ListItemText primary="Manage all bookings"/></Link>
          </ListItem>
          <ListItem button>
            <ListItemIcon>
             <AddCircleIcon />
            </ListItemIcon>
            <Link to={`${url}/addappartment`} style={{ textDecoration: 'none', fontWeight: 'bold', color: '#184640' }}><ListItemText primary="Add Appartment"/></Link>
          </ListItem>
          <ListItem button>
            <ListItemIcon>
             < ApartmentIcon />
            </ListItemIcon>
            <Link to={`${url}/manageappartments`} style={{ textDecoration: 'none', fontWeight: 'bold', color: '#184640' }}><ListItemText primary="Manage Appartments"/></Link>
          </ListItem>
          <ListItem button>
            <ListItemIcon>
             <AccountCircleIcon />
            </ListItemIcon>
            <Link to={`${url}/makeadmin`} style={{ textDecoration: 'none', fontWeight: 'bold', color: '#184640' }}><ListItemText primary="Make Admin"/></Link>
          </ListItem>
          <Divider/>
          <ListItem button>
            
            <ListItemIcon>
             <LogoutIcon />
            </ListItemIcon>
            <button onClick={logOut} className='custom-btn'>Logout</button>
          </ListItem>
            </List>
          }

      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar className='custom-bg' >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
          <img src="../../../Images/logo2.png" alt=""/>
            Appartment Dashboard
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
        <Toolbar />
        <Switch>
        <Route exact path={path}>
        <MyBookings></MyBookings>
        </Route>
        <Route path={`${path}/mybookings`}>
        <MyBookings></MyBookings>
        </Route>
        <Route path={`${path}/addreview`}>
          <Reviews></Reviews>
        </Route>
        <Route path={`${path}/pay`}>
          <Pay></Pay>
        </Route>
        <Route path={`${path}/managebookings`}>
          <Managebooking></Managebooking>
        </Route>
        <Route path={`${path}/mybookings`}>
        <MyBookings></MyBookings>
        </Route>
        <Route path={`${path}/addappartment`}>
          <AddAppartment></AddAppartment>
        </Route>
        <Route path={`${path}/manageappartments`}>
        <ManageAppartments></ManageAppartments>
        </Route>
        <Route path={`${path}/makeadmin`}>
        <MakeAdmin></MakeAdmin>
        </Route>
      </Switch>
      </Box>
    </Box>
  );
}

Dashboard.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default Dashboard;
